<div class="viewcontainer">
  <div class="head">
      <app-header [Message]="Header" [Action]="ButtonAction" [ConfirmHead]='confirmHeading' [Visible]='visible' [Confirmbody]='confirmBody' (exposeChild)="showDataFromChild($event)"></app-header>
  </div>
  <div class="flex-containter">
      <div class="portion">
          <div class="Title"> Camfil Authorized Distributer</div>
          <div class="infoContainer">
              <div class="formgroup">
                  <label class="inputlabel">REP / Dist / RSM</label>
                  <input type="text" [(ngModel)]='rep' class="inputtext">
              </div>
              <div class="formgroup">
                  <label class="inputlabel">Street </label>
                  <input type="text" [(ngModel)]='street' class="inputtext">
              </div>
              <div class="formgroup">
                  <label class="inputlabel">City</label>
                  <input type="text" [(ngModel)]='city' class="inputtext">
              </div>
              <div class="formgroup">
                  <label class="inputlabel">State / Province</label>
                  <input type="text" [(ngModel)]='state' class="inputtext">
              </div>
              <div class="formgroup">
                  <label class="inputlabel">Zip / Postal code</label>
                  <input type="text" [(ngModel)]='postal' class="inputtext">
              </div>
              <div class="formgroup">
                  <label class="inputlabel">Country</label>
                  <input type="text" [(ngModel)]='country' class="inputtext">
              </div>
          </div>
      </div>
      <div class="portion">
          <div class="Title"> Prepared by</div>
          <div class="infoContainer">
              <div class="formgroup">
                  <label class="inputlabel">Name</label>
                  <input type="text" [(ngModel)]='name' class="inputtext">
              </div>
              <div class="formgroup">
                  <label class="inputlabel">Designation / Title</label>
                  <input type="text" [(ngModel)]='designation' class="inputtext">
              </div>
          </div>
      </div>
  </div>
</div>

